module.exports = __webpack_public_path__ + "static/img/8.a8aa0cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/8.png
// module id = VwvY
// module chunks = 0